import { memo } from 'react';
import { Link } from 'react-router';
import { BettyIgoLogo, Box } from '@betty/moonlight';

import { CashBalanceHeaderItem, CoinBalanceHeaderItem } from '@betty/wallet';
import { LevelHeaderItem } from '@betty/levels';
import { StatusHeaderItem } from '@betty/status';
import { InboxHeaderItem } from '@betty/inbox';
import MainHeaderCTA from './MainHeaderCTA';
import LinkedBettyIgoLogo from '../../LinkedBettyIgoLogo';

function MobileMainHeader() {
  return (
    <Box alignItems="center" gap="space-200" padding="space-400">
      <Box centerContent>
        <LinkedBettyIgoLogo />
      </Box>
      <Box
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        gap="space-200"
      >
        <CashBalanceHeaderItem />
        <CoinBalanceHeaderItem />
        <MainHeaderCTA />
      </Box>
      <Box
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        gap="space-200"
      >
        <LevelHeaderItem flex={1} />
        <StatusHeaderItem flex={1} />
        <InboxHeaderItem />
      </Box>
    </Box>
  );
}

export default memo(MobileMainHeader);
